import React from 'react'
import PropTypes from 'prop-types'
import { IconButtonWrapper } from './style'

const MuiIconButton = (props) => {
  return (
    <IconButtonWrapper {...props}>
      {props.children}
    </IconButtonWrapper>
  )
}

MuiIconButton.propTypes = {
  children: PropTypes.node
}

export default MuiIconButton
